function phoneMask() {
    var Inputmask = require("inputmask");
    Inputmask({mask: "999-999-9999" }).mask("input.phoneMask");
}
module.exports = {
    phoneMask: phoneMask
};
